import { BottomLeftBar } from "@/interface/BottomBar/BottomLeftBar";
import { BottomRightBar } from "@/interface/BottomBar/BottomRightBar";

export const BottomBar = () => {
    return (
        <>
            <BottomLeftBar />
            <BottomRightBar />
        </>
    );
};
